import Turnstile from "react-turnstile";
import { useSignupAnon } from "../api/useSignupAnon";
import { useErrorToast } from "../hooks/useErrorToast";

export function TryFree() {
  const { signupAnon, error } = useSignupAnon();
  useErrorToast(error);
  return (
    <div className="w-screen h-screen grid place-items-center font-body items-center">
      <h1 className="text-6xl font-terminal w-full flex justify-center flex-row items-center">
        Verifying you are human
        <Ellipses />
      </h1>
      <Turnstile
        className=""
        sitekey={import.meta.env.VITE_TURNSTILE_SITE_KEY as string}
        onVerify={async (token) => {
          try {
            const res = await signupAnon(token);
            if (res.success) {
              window.location.href = `${import.meta.env.VITE_TINKER_URL}/app`;
            }
          } catch (err) {}
        }}
        onError={(err) => {
          console.error(err);
        }}
      />
    </div>
  );
}

function Ellipses() {
  return <span className="ellipses w-20"></span>;
}
